import { defineNuxtPlugin } from '#app';
import scrollToDirective from '../directives/scroll-to';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('scroll-to', scrollToDirective);
});
